import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { tConsume } from 'TRANSLATION';
import './topbar.less';

const Topbar = () => {
  // const { menuConfig } = useSelector((state) => state.menu);
  const personalData = useSelector((state) => state.personal.data);
  const userEmail = useSelector((state) => state.personal.email);
  // console.log(personalData);
  // console.log(userEmail);

  // const unreadMessages = useSelector((state) => state.cases.unread);
  // const location = useLocation();

  // const [status, setStatus] = useState('');

  //console.log('personalData', personalData);
  const { email, id } = personalData;
  // const isDirector =
  //   (personalData.profile_type === 'DIRECTOR' || personalData.profile_type === 'STAFF') &&
  //   personalData.company &&
  //   personalData.company.name;

  // useEffect(() => {
  //   let isMounted = true;
  //
  //   const getStatus = async () => {
  //     try {
  //       const response = await axios.get(api.system.version);
  //       if (isMounted) {
  //         setStatus(config?.meta?.tag === response?.data?.frontend_tag);
  //       }
  //     } catch (error) {
  //       if (isMounted) responseError(error);
  //     }
  //   };
  //
  //   getStatus();
  //
  //   return () => {
  //     isMounted = false;
  //   };
  // }, []);

  // const renderOverlay = () => {
  //   const { defaultOpenKeys, defaultSelectedKeys } = getDefaultKeys(menuConfig, location);
  //
  //   return (
  //     <Menu
  //       className='dashboard-wrapper-menu'
  //       style={{ borderRight: 'none' }}
  //       defaultOpenKeys={defaultOpenKeys}
  //       defaultSelectedKeys={defaultSelectedKeys}
  //     >
  //       <Menu.Item>
  //         <NavLink to={`/${userType}/logout`}>
  //           <>
  //             <Icon type='logout' />
  //             <span>Log out</span>
  //           </>
  //         </NavLink>
  //       </Menu.Item>
  //     </Menu>
  //   );
  // };

  const renderName = () => {
    const { title, first_name, last_name, middle_name } = personalData;
    return first_name ? `${title ? `${title}.` : ''} ${first_name} ${middle_name || ''} ${last_name}` : '';
  };

  return (
    <div className='topbar'>
      <div className='topbar__header'>
        <div className='topbar__title'>FinClub - Balance Overview</div>
        <div className='topbar__main'>
          {/*<div className='change'>*/}
          {/*  <ChangeCircle />*/}
          {/*</div>*/}

          <div className='user'>
            {/*<span className='name'>{renderName()}</span>*/}
            <span className='email'>{userEmail}</span>
          </div>
          {/*<div className='user-info'>*/}
          {/*  <span className='title'>USER ID</span>*/}
          {/*  <span className='subtitle'>#{id}</span>*/}
          {/*</div>*/}
        </div>
        {/*<Dropdown trigger={['click']} placement='bottomRight' overlay={renderOverlay()}>*/}
        {/*  <Button type='link' size='large' className={'profile'}>*/}
        {/*    <UserAvatar name={`${first_name} ${last_name}`} />*/}
        {/*    <span className='header-profileName'>*/}
        {/*      <span>*/}
        {/*        {renderName()}*/}
        {/*        {isDirector && (*/}
        {/*          <>*/}
        {/*            <br />*/}
        {/*            Company: <b>{personalData.company.name}</b>*/}
        {/*          </>*/}
        {/*        )}*/}
        {/*      </span>*/}
        {/*      <Icon type='down' />*/}
        {/*    </span>*/}
        {/*  </Button>*/}
        {/*</Dropdown>*/}
      </div>
    </div>
  );
};

export default tConsume(Topbar);

Topbar.propTypes = {
  userType: PropTypes.string,
  t: PropTypes.func.isRequired,
};
